import React, { useState } from 'react';
import { StaffProviderModal } from '.';
import ChangeHighglightedImmutableUnderReviewDropdown from '@rd-web-markets/shared/dist/util/reviewEditControls/ChangeHighglightedImmutableUnderReviewDropdown';
export default function StaffProviderDropdown(_ref) {
  let {
    claim,
    claimExternalWorker,
    userUnauthorizedToEdit,
    onChange,
    onBlur,
    refreshClaim
  } = _ref;
  const [showStaffProviderModal, setShowStaffProviderModal] = useState(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, showStaffProviderModal && /*#__PURE__*/React.createElement(StaffProviderModal, {
    claim: claim,
    show: showStaffProviderModal,
    onHide: () => setShowStaffProviderModal(false),
    onSubmit: staffProvider => {
      refreshClaim();
      onChange({
        target: {
          name: 'staff_provider_id',
          value: staffProvider.id
        }
      });
      onBlur();
    }
  }), /*#__PURE__*/React.createElement(ChangeHighglightedImmutableUnderReviewDropdown, {
    claim: claim,
    valuesArray: claim.company.staff_providers,
    edittedObject: claimExternalWorker,
    edittedObjectFieldName: 'staff_provider_id',
    userUnauthorizedToEdit: userUnauthorizedToEdit,
    onChange: onChange,
    onBlur: onBlur,
    refreshClaim: refreshClaim,
    onCreate: () => {
      setShowStaffProviderModal(true);
    }
  }));
}